/**
 * Back from the checkout (or any page) the browser can show the store page from its cache: the markup, the cart
 * drawer included, is then the cart as it was when that page was first loaded. The theme only refreshes the drawer
 * when the page comes out of the back/forward cache, so in the other cases the drawer showed old or missing lines
 * (Progus also rewrites the lines on the way to its Mollie checkout).
 *
 * So whenever a page is shown, the cart's lines are compared with the drawer's (line key and quantity, see
 * data-line-key in snippets/line-item.liquid). If they differ, a
 * cart:refresh lets the theme re-render the drawer and the count, and assets/cart-gift.js and assets/cart-refills.js
 * check the gift and the refill plans again. The check reads cart.js uncached, which the theme's own read may not.
 */

const ROOT = window.Shopify?.routes?.root ?? '/';

async function refreshIfStale() {
  const drawer = document.querySelector('cart-drawer');

  if (!drawer) return;

  try {
    const response = await fetch(`${ROOT}cart.js`, { cache: 'no-store', headers: { Accept: 'application/json' } });

    if (!response.ok) return;

    const cart = await response.json();
    const cartKeys = cart.items.map((item) => `${item.key}:${item.quantity}`).sort().join(',');
    const drawerKeys = Array.from(drawer.querySelectorAll('line-item[data-line-key]'), (line) => line.dataset.lineKey)
      .sort()
      .join(',');
    const drawerCount = drawer.querySelectorAll('line-item').length;

    // Without keys in the markup, the number of lines is the next best check
    const stale = drawerKeys ? drawerKeys !== cartKeys : drawerCount !== cart.items.length;

    if (stale) document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  } catch (error) {
    console.warn('[cart-back-refresh] Could not check the cart.', error);
  }
}

window.addEventListener('pageshow', refreshIfStale);
